/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".setting{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;-webkit-box-align:center;align-items:center;position:relative;padding-bottom:10px}.setting>label{white-space:nowrap;padding-right:10px;display:inline-block;margin:0}.setting>input,.setting>select{flex-basis:75%}.setting>mc-color-picker-ng{display:inline-block;flex-basis:75%}"];
export { styles as styles };
